/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesOrganizationSchema } from "./organizationSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesOrganizationTwitchAuthSchema = z.object({
  organizationId: z.optional(z.uuid()),
  twitchId: z.string().min(1),
  login: z.string().min(1),
  accessToken: z.string().nullish(),
  refreshToken: z.string().nullish(),
  tokenExpiry: z.iso.datetime().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  updatedAt: z.optional(z.iso.datetime()),
  get organization() {
    return goodLuckCoreEntitiesOrganizationSchema.optional();
  },
});
